import type { AssignmentStatus } from '../../shared/api/types';

export const ASSIGNMENT_STATUS: Record<AssignmentStatus, { label: string; tone: string }> = {
  requested: { label: 'Por confirmar', tone: 'badge--warn' },
  accepted: { label: 'Confirmado', tone: 'badge--active' },
  declined: { label: 'No puede', tone: '' },
  canceled: { label: 'Retirado', tone: '' },
};

/** "2026-10-04" → "4 oct 2026" sin desfase de zona horaria. */
export function formatDay(day: string): string {
  const [y, m, d] = day.split('-').map(Number) as [number, number, number];
  return new Date(y, m - 1, d).toLocaleDateString('es', { day: 'numeric', month: 'short', year: 'numeric' });
}
